import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import { useTranslation } from 'react-i18next';
import PoliciesResponsesMainSection from './sections/PoliciesResponsesMainSection';
import PoliciesResponsesSubSection from './sections/PoliciesResponsesSubSection';
  


const GlobalRegionalDistributionGraphs = (props) => {
        const { t } = useTranslation();
        const [dataForGraphsGlobal, setDataForGraphsGlobal] = useState('');
        const [dataForGraphsRegional, setDataForGraphsRegional] = useState('');
        const [dataForTimelineGlobalA11, setDataForTimelineGlobalA11] = useState('');
        const [dataForTimelineGlobalA12, setDataForTimelineGlobalA12] = useState('');
        const [dataForTimelineGlobalA21, setDataForTimelineGlobalA21] = useState('');
        const [dataForTimelineGlobalA22, setDataForTimelineGlobalA22] = useState('');
         const [dataForTimelineGlobalA31, setDataForTimelineGlobalA31] = useState('');
        const [dataForTimelineGlobalA33, setDataForTimelineGlobalA33] = useState('');
        const [dataForTimelineGlobalA41, setDataForTimelineGlobalA41] = useState('');
        const [dataForTimelineGlobalA42, setDataForTimelineGlobalA42] = useState('');
        const [dataForTimelineRegional, setDataForTimelineRegional] = useState('');
       
        const [size, setSize] = useState({ x: 0,y:0});
  
  

  useEffect(() => {
    const updateSize = () =>
    setSize({
      x: window.innerWidth,
      y: window.innerHeight
    });
    console.log("set size");
    console.log(size.x);
        const setData = async () => {
          console.log(props.dataRegional);
          var dataRegional = [];
            props.dataRegional.forEach((region) => {
              //question A1.1 main
            dataRegional.push(  
          [region.filter(ques => ques.question === 5 && ques.answer === 6).length, 
          region.filter(ques => ques.question === 5 && ques.answer === 14).length, 
          region.filter(ques => ques.question === 5 && ques.answer === 15).length, 
          region.filter(ques => ques.question === 5 && ques.answer === 16).length],
        
          // question A1.1 sub 
          [
          region.filter(ques => ques.question === 8 && ques.answer === 9).length,
          region.filter(ques => ques.question === 8 && ques.answer === 10).length,
          region.filter(ques => ques.question === 8 && ques.answer === 11).length,
          region.filter(ques => ques.question === 8 && ques.answer === 12).length,
          region.filter(ques => ques.question === 8 && ques.answer === 13).length],

          //question A1.2 main
          [region.filter(ques => ques.question === 19 && ques.answer === 20).length, 
          region.filter(ques => ques.question === 19 && ques.answer === 28).length, 
          region.filter(ques => ques.question === 19 && ques.answer === 29).length, 
          region.filter(ques => ques.question === 19 && ques.answer === 30).length],
          
          //question A1.2 sub
          [region.filter(ques => ques.question === 22 && ques.answer === 23).length,
          region.filter(ques => ques.question === 22 && ques.answer === 24).length,
          region.filter(ques => ques.question === 22 && ques.answer === 25).length,
          region.filter(ques => ques.question === 22 && ques.answer === 26).length,
          region.filter(ques => ques.question === 22 && ques.answer === 27).length],

          //question A2.1 main
          [region.filter(ques => ques.question === 34 && ques.answer === 35).length, 
          region.filter(ques => ques.question === 34 && ques.answer === 42).length, 
          region.filter(ques => ques.question === 34 && ques.answer === 43).length, 
          region.filter(ques => ques.question === 34 && ques.answer === 44).length],
          
          //question A2.1  sub
          [region.filter(ques => ques.question === 37 && ques.answer === 38).length,
          region.filter(ques => ques.question === 37 && ques.answer === 39).length,
          region.filter(ques => ques.question === 37 && ques.answer === 40).length,
          region.filter(ques => ques.question === 37 && ques.answer === 41).length],

          //question A2.2 main
          [region.filter(ques => ques.question === 47 && ques.answer === 48).length, 
          region.filter(ques => ques.question === 47 && ques.answer === 55).length, 
          region.filter(ques => ques.question === 47 && ques.answer === 56).length, 
          region.filter(ques => ques.question === 47 && ques.answer === 57).length],
              
          //question A2.2 sub
          [region.filter(ques => ques.question === 50 && ques.answer === 51).length,
          region.filter(ques => ques.question === 50 && ques.answer === 52).length,
          region.filter(ques => ques.question === 50 && ques.answer === 53).length,
          region.filter(ques => ques.question === 50 && ques.answer === 54).length],


           //question A3.1 main
          [region.filter(ques => ques.question === 61 && ques.answer === 62).length, 
          region.filter(ques => ques.question === 61 && ques.answer === 64).length, 
          region.filter(ques => ques.question === 61 && ques.answer === 65).length, 
          region.filter(ques => ques.question === 61 && ques.answer === 66).length],
              
          //question A3.2 main
          [region.filter(ques => ques.question === 69 && ques.answer === 70).length,
          region.filter(ques => ques.question === 69 && ques.answer === 76).length,
          region.filter(ques => ques.question === 69 && ques.answer === 77).length,
          region.filter(ques => ques.question === 69 && ques.answer === 78).length],

            //question A3.2 sub
          [region.filter(ques => ques.question === 71 && ques.answer === 72).length,
          region.filter(ques => ques.question === 71 && ques.answer === 73).length,
          region.filter(ques => ques.question === 71 && ques.answer === 74).length,
          region.filter(ques => ques.question === 71 && ques.answer === 75).length],

            //question A3.3 main
          [region.filter(ques => ques.question === 81 && ques.answer === 82).length,
          region.filter(ques => ques.question === 81 && ques.answer === 89).length,
          region.filter(ques => ques.question === 81 && ques.answer === 90).length,
          region.filter(ques => ques.question === 81 && ques.answer === 91).length],

            //question A3.3 sub
          [region.filter(ques => ques.question === 84 && ques.answer === 85).length,
          region.filter(ques => ques.question === 84 && ques.answer === 86).length,
          region.filter(ques => ques.question === 84 && ques.answer === 87).length,
          region.filter(ques => ques.question === 84 && ques.answer === 88).length],

               //question A4.1 main
          [region.filter(ques => ques.question === 95 && ques.answer === 96).length,
          region.filter(ques => ques.question === 95 && ques.answer === 107).length,
          region.filter(ques => ques.question === 95 && ques.answer === 108).length,
          region.filter(ques => ques.question === 95 && ques.answer === 109).length],

            //question A4.1 sub
          [region.filter(ques => ques.question === 98 && ques.answer === 99).length,
          region.filter(ques => ques.question === 98 && ques.answer === 100).length,
          region.filter(ques => ques.question === 98 && ques.answer === 101).length,
          region.filter(ques => ques.question === 98 && ques.answer === 102).length,
          region.filter(ques => ques.question === 98 && ques.answer === 103).length,
          region.filter(ques => ques.question === 98 && ques.answer === 104).length,
          region.filter(ques => ques.question === 98 && ques.answer === 105).length,
          region.filter(ques => ques.question === 98 && ques.answer === 106).length],

            //question A4.2 main
          [region.filter(ques => ques.question === 112 && ques.answer === 113).length,
          region.filter(ques => ques.question === 112 && ques.answer === 119).length,
          region.filter(ques => ques.question === 112 && ques.answer === 120).length,
          region.filter(ques => ques.question === 112 && ques.answer === 121).length],

            //question A4.1 sub
          [region.filter(ques => ques.question === 115 && ques.answer === 116).length,
          region.filter(ques => ques.question === 115 && ques.answer === 117).length,
          region.filter(ques => ques.question === 115 && ques.answer === 118).length],
        
              //question A4.3 main
          [region.filter(ques => ques.question === 124 && ques.answer === 125).length,
          region.filter(ques => ques.question === 124 && ques.answer === 126).length,
          region.filter(ques => ques.question === 124 && ques.answer === 127).length,
          region.filter(ques => ques.question === 124 && ques.answer === 128).length],

              //question B4.1.1 
          [region.filter(ques => ques.question === 191 && ques.answer === 192).length,
          region.filter(ques => ques.question === 191 && ques.answer === 193).length,
          region.filter(ques => ques.question === 191 && ques.answer === 194).length,
          region.filter(ques => ques.question === 191 && ques.answer === 195).length,
          region.filter(ques => ques.question === 191 && ques.answer === 196).length],

           //question B4.1.2 
          [region.filter(ques => ques.question === 198 && ques.answer === 199).length,
          region.filter(ques => ques.question === 198 && ques.answer === 200).length,
          region.filter(ques => ques.question === 198 && ques.answer === 201).length,
          region.filter(ques => ques.question === 198 && ques.answer === 202).length,
          region.filter(ques => ques.question === 198 && ques.answer === 203).length],

            //question B4.1.3
          [region.filter(ques => ques.question === 205 && ques.answer === 206).length,
          region.filter(ques => ques.question === 205 && ques.answer === 207).length,
          region.filter(ques => ques.question === 205 && ques.answer === 208).length,
          region.filter(ques => ques.question === 205 && ques.answer === 209).length,
          region.filter(ques => ques.question === 205 && ques.answer === 210).length],

              //question B4.2 
          [region.filter(ques => ques.question === 213 && ques.answer === 214).length,
          region.filter(ques => ques.question === 213 && ques.answer === 216).length,
          region.filter(ques => ques.question === 213 && ques.answer === 217).length,
          region.filter(ques => ques.question === 213 && ques.answer === 218).length],

            //question B4.3
          [region.filter(ques => ques.question === 221 && ques.answer === 222).length,
          region.filter(ques => ques.question === 221 && ques.answer === 224).length,
          region.filter(ques => ques.question === 221 && ques.answer === 225).length,
          region.filter(ques => ques.question === 221 && ques.answer === 226).length,
          region.filter(ques => ques.question === 221 && ques.answer === 227).length],

             //question B4.3 sub
          [region.filter(ques => ques.question === 223 ).length]
        );
        
        });
          setDataForGraphsRegional(dataRegional);
          
  

        setDataForGraphsGlobal(
          [
          //question A1.1 main
          props.dataGlobal.filter(ques => ques.question === 5 && ques.answer === 6).length, 
          props.dataGlobal.filter(ques => ques.question === 5 && ques.answer === 14).length, 
          props.dataGlobal.filter(ques => ques.question === 5 && ques.answer === 15).length, 
          props.dataGlobal.filter(ques => ques.question === 5 && ques.answer === 16).length,
          
          // question A1.1 sub
          props.dataGlobal.filter(ques => ques.question === 8 && ques.answer === 9).length,
          props.dataGlobal.filter(ques => ques.question === 8 && ques.answer === 10).length,
          props.dataGlobal.filter(ques => ques.question === 8 && ques.answer === 11).length,
          props.dataGlobal.filter(ques => ques.question === 8 && ques.answer === 12).length,
          props.dataGlobal.filter(ques => ques.question === 8 && ques.answer === 13).length,

          //question A1.2 main
          props.dataGlobal.filter(ques => ques.question === 19 && ques.answer === 20).length, 
          props.dataGlobal.filter(ques => ques.question === 19 && ques.answer === 28).length, 
          props.dataGlobal.filter(ques => ques.question === 19 && ques.answer === 29).length, 
          props.dataGlobal.filter(ques => ques.question === 19 && ques.answer === 30).length,
          
          //question A1.2 sub
          props.dataGlobal.filter(ques => ques.question === 22 && ques.answer === 23).length,
          props.dataGlobal.filter(ques => ques.question === 22 && ques.answer === 24).length,
          props.dataGlobal.filter(ques => ques.question === 22 && ques.answer === 25).length,
          props.dataGlobal.filter(ques => ques.question === 22 && ques.answer === 26).length,
          props.dataGlobal.filter(ques => ques.question === 22 && ques.answer === 27).length,

          //question A2.1 main
          props.dataGlobal.filter(ques => ques.question === 34 && ques.answer === 35).length, 
          props.dataGlobal.filter(ques => ques.question === 34 && ques.answer === 42).length, 
          props.dataGlobal.filter(ques => ques.question === 34 && ques.answer === 43).length, 
          props.dataGlobal.filter(ques => ques.question === 34 && ques.answer === 44).length,
          
          //question A2.1  sub
          props.dataGlobal.filter(ques => ques.question === 37 && ques.answer === 38).length,
          props.dataGlobal.filter(ques => ques.question === 37 && ques.answer === 39).length,
          props.dataGlobal.filter(ques => ques.question === 37 && ques.answer === 40).length,
          props.dataGlobal.filter(ques => ques.question === 37 && ques.answer === 41).length,

          //question A2.2 main
          props.dataGlobal.filter(ques => ques.question === 47 && ques.answer === 48).length, 
          props.dataGlobal.filter(ques => ques.question === 47 && ques.answer === 55).length, 
          props.dataGlobal.filter(ques => ques.question === 47 && ques.answer === 56).length, 
          props.dataGlobal.filter(ques => ques.question === 47 && ques.answer === 57).length,
              
          //question A2.2 sub
          props.dataGlobal.filter(ques => ques.question === 50 && ques.answer === 51).length,
          props.dataGlobal.filter(ques => ques.question === 50 && ques.answer === 52).length,
          props.dataGlobal.filter(ques => ques.question === 50 && ques.answer === 53).length,
          props.dataGlobal.filter(ques => ques.question === 50 && ques.answer === 54).length,

           //question A3.1 main
          props.dataGlobal.filter(ques => ques.question === 61 && ques.answer === 62).length, 
          props.dataGlobal.filter(ques => ques.question === 61 && ques.answer === 64).length, 
          props.dataGlobal.filter(ques => ques.question === 61 && ques.answer === 65).length, 
          props.dataGlobal.filter(ques => ques.question === 61 && ques.answer === 66).length,
              
          //question A3.2 main
          props.dataGlobal.filter(ques => ques.question === 69 && ques.answer === 70).length,
          props.dataGlobal.filter(ques => ques.question === 69 && ques.answer === 76).length,
          props.dataGlobal.filter(ques => ques.question === 69 && ques.answer === 77).length,
          props.dataGlobal.filter(ques => ques.question === 69 && ques.answer === 78).length,

            //question A3.2 sub
          props.dataGlobal.filter(ques => ques.question === 71 && ques.answer === 72).length,
          props.dataGlobal.filter(ques => ques.question === 71 && ques.answer === 73).length,
          props.dataGlobal.filter(ques => ques.question === 71 && ques.answer === 74).length,
          props.dataGlobal.filter(ques => ques.question === 71 && ques.answer === 75).length,

            //question A3.3 main
          props.dataGlobal.filter(ques => ques.question === 81 && ques.answer === 82).length,
          props.dataGlobal.filter(ques => ques.question === 81 && ques.answer === 89).length,
          props.dataGlobal.filter(ques => ques.question === 81 && ques.answer === 90).length,
          props.dataGlobal.filter(ques => ques.question === 81 && ques.answer === 91).length,

            //question A3.3 sub
          props.dataGlobal.filter(ques => ques.question === 84 && ques.answer === 85).length,
          props.dataGlobal.filter(ques => ques.question === 84 && ques.answer === 86).length,
          props.dataGlobal.filter(ques => ques.question === 84 && ques.answer === 87).length,
          props.dataGlobal.filter(ques => ques.question === 84 && ques.answer === 88).length,

               //question A4.1 main
          props.dataGlobal.filter(ques => ques.question === 95 && ques.answer === 96).length,
          props.dataGlobal.filter(ques => ques.question === 95 && ques.answer === 107).length,
          props.dataGlobal.filter(ques => ques.question === 95 && ques.answer === 108).length,
          props.dataGlobal.filter(ques => ques.question === 95 && ques.answer === 109).length,

            //question A4.1 sub
          props.dataGlobal.filter(ques => ques.question === 98 && ques.answer === 99).length,
          props.dataGlobal.filter(ques => ques.question === 98 && ques.answer === 100).length,
          props.dataGlobal.filter(ques => ques.question === 98 && ques.answer === 101).length,
          props.dataGlobal.filter(ques => ques.question === 98 && ques.answer === 102).length,
          props.dataGlobal.filter(ques => ques.question === 98 && ques.answer === 103).length,
          props.dataGlobal.filter(ques => ques.question === 98 && ques.answer === 104).length,
          props.dataGlobal.filter(ques => ques.question === 98 && ques.answer === 105).length,
          props.dataGlobal.filter(ques => ques.question === 98 && ques.answer === 106).length,

            //question A4.2 main
          props.dataGlobal.filter(ques => ques.question === 112 && ques.answer === 113).length,
          props.dataGlobal.filter(ques => ques.question === 112 && ques.answer === 119).length,
          props.dataGlobal.filter(ques => ques.question === 112 && ques.answer === 120).length,
          props.dataGlobal.filter(ques => ques.question === 112 && ques.answer === 121).length,

            //question A4.1 sub
          props.dataGlobal.filter(ques => ques.question === 115 && ques.answer === 116).length,
          props.dataGlobal.filter(ques => ques.question === 115 && ques.answer === 117).length,
          props.dataGlobal.filter(ques => ques.question === 115 && ques.answer === 118).length,
        
              //question A4.3 main
          props.dataGlobal.filter(ques => ques.question === 124 && ques.answer === 125).length,
          props.dataGlobal.filter(ques => ques.question === 124 && ques.answer === 126).length,
          props.dataGlobal.filter(ques => ques.question === 124 && ques.answer === 127).length,
          props.dataGlobal.filter(ques => ques.question === 124 && ques.answer === 128).length,

              //question B4.1.1 
          props.dataGlobal.filter(ques => ques.question === 191 && ques.answer === 192).length,
          props.dataGlobal.filter(ques => ques.question === 191 && ques.answer === 193).length,
          props.dataGlobal.filter(ques => ques.question === 191 && ques.answer === 194).length,
          props.dataGlobal.filter(ques => ques.question === 191 && ques.answer === 195).length,
          props.dataGlobal.filter(ques => ques.question === 191 && ques.answer === 196).length,

           //question B4.1.2 
          props.dataGlobal.filter(ques => ques.question === 198 && ques.answer === 199).length,
          props.dataGlobal.filter(ques => ques.question === 198 && ques.answer === 200).length,
          props.dataGlobal.filter(ques => ques.question === 198 && ques.answer === 201).length,
          props.dataGlobal.filter(ques => ques.question === 198 && ques.answer === 202).length,
          props.dataGlobal.filter(ques => ques.question === 198 && ques.answer === 203).length,

            //question B4.1.3
          props.dataGlobal.filter(ques => ques.question === 205 && ques.answer === 206).length,
          props.dataGlobal.filter(ques => ques.question === 205 && ques.answer === 207).length,
          props.dataGlobal.filter(ques => ques.question === 205 && ques.answer === 208).length,
          props.dataGlobal.filter(ques => ques.question === 205 && ques.answer === 209).length,
          props.dataGlobal.filter(ques => ques.question === 205 && ques.answer === 210).length,

              //question B4.2 
          props.dataGlobal.filter(ques => ques.question === 213 && ques.answer === 214).length,
          props.dataGlobal.filter(ques => ques.question === 213 && ques.answer === 216).length,
          props.dataGlobal.filter(ques => ques.question === 213 && ques.answer === 217).length,
          props.dataGlobal.filter(ques => ques.question === 213 && ques.answer === 218).length,

            //question B4.3
          props.dataGlobal.filter(ques => ques.question === 221 && ques.answer === 222).length,
          props.dataGlobal.filter(ques => ques.question === 221 && ques.answer === 224).length,
          props.dataGlobal.filter(ques => ques.question === 221 && ques.answer === 225).length,
          props.dataGlobal.filter(ques => ques.question === 221 && ques.answer === 226).length,
          props.dataGlobal.filter(ques => ques.question === 221 && ques.answer === 227).length,

             //question B4.3 sub
          props.dataGlobal.filter(ques => ques.question === 223 ).length


        ],
     );
      setDataForTimelineGlobalA11( props.dataGlobal.filter(ques => ques.question === 7))
      setDataForTimelineGlobalA12( props.dataGlobal.filter(ques => ques.question === 21))
      setDataForTimelineGlobalA21( props.dataGlobal.filter(ques => ques.question === 36))
      setDataForTimelineGlobalA22( props.dataGlobal.filter(ques => ques.question === 49))
      setDataForTimelineGlobalA31( props.dataGlobal.filter(ques => ques.question === 63))
      setDataForTimelineGlobalA33( props.dataGlobal.filter(ques => ques.question === 83))
      setDataForTimelineGlobalA41( props.dataGlobal.filter(ques => ques.question === 97))
      setDataForTimelineGlobalA42( props.dataGlobal.filter(ques => ques.question === 114))


          var dataTimelineRegional = [];
            props.dataRegional.forEach((region) => {
       
            dataTimelineRegional.push( [
              region.filter(ques => ques.question === 7), 
              region.filter(ques => ques.question === 21), 
              region.filter(ques => ques.question === 36), 
              region.filter(ques => ques.question === 49),
              region.filter(ques => ques.question === 63), 
              region.filter(ques => ques.question === 83), 
              region.filter(ques => ques.question === 97), 
              region.filter(ques => ques.question === 114)])});
            
            
              setDataForTimelineRegional(dataTimelineRegional);



      };
  
      setData();
      window.onresize = updateSize();
  }, [props.lang, props.dataGlobal, props.dataRegional, size.x ]);
  console.log("data here");
  console.log(dataForGraphsRegional);

  // console.log(dataForGraphsRegional);
  console.log(size);
    return (
      <div className="App">
        {dataForGraphsGlobal !== undefined && dataForGraphsGlobal !== "" &&
      <Container >
        <br></br>
         <br></br>
        <Row className="pdf-rendering justify-content-md-center">
          
          {/* Target Title */}
          <Row>
          <p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-target-title-bold-text">{
            props.target === "target_A1" ? 
            t('targetA1_title') : 
            props.target === "target_A2" ? 
            t('targetA2_title') : 
            props.target === "target_A3" ? 
            t('targetA3_title'): 
            props.target === "target_A4" ? 
            t('targetA4_title'): 
            t('targetB4_title')} </span>
            
            <span className="table-target-title-non-bold-text">{
            props.target === "target_A1" ? 
            t('targetA1_text') : 
            props.target === "target_A2" ? 
            t('targetA2_text') :
            props.target === "target_A3" ? 
            t('targetA3_text') :
            props.target === "target_A4" ? 
            t('targetA4_text') : 
            t('targetB4_text') }</span></p></Row>
          

     {/*First graph main question */}
      <PoliciesResponsesMainSection 
        size={size}
      indicatorTitle={props.target === "target_A1" ?  'indicatorA11_title' : 
                      props.target === "target_A2" ?  'indicatorA21_title' :
                      props.target === "target_A3" ?  'indicatorA31_title' :
                      props.target === "target_A4" ?  'indicatorA41_title' : 'indicatorB41_title'}
      
      indicatorText={props.target === "target_A1" ? 'indicatorA11_text' :
                    props.target === "target_A2" ? 'indicatorA21_text' :
                    props.target === "target_A3" ? 'indicatorA31_text' :
                    props.target === "target_A4" ? 'indicatorA41_text' : 'indicatorB41_text'}
      
      graphTitle={props.target === "target_A1" ? 'graphA11_title1' : 
                  props.target === "target_A2" ? 'graphA21_title1' :
                  props.target === "target_A3" ? 'graphA31_title1' : 
                  props.target === "target_A4" ? 'graphA41_title1' :
                  'graphB41_title1'
                } 
      titleY='graphA11_ybar_label1'
      titleX='global_title'
      type={props.type}
      dataGlobal={props.target === "target_A1" ? 
      dataForGraphsGlobal.slice(0,4) : 
      props.target === "target_A2" ? 
      dataForGraphsGlobal.slice(18,22) :
      props.target === "target_A3" ?
      dataForGraphsGlobal.slice(34,38) :
      props.target === "target_A4" ?
      dataForGraphsGlobal.slice(54,58) :
     dataForGraphsGlobal.slice(77,82)} 
      dataRegional={props.target === "target_A1" ? 
                                          [dataForGraphsRegional[0],
                                          dataForGraphsRegional[24],
                                          dataForGraphsRegional[48],
                                          dataForGraphsRegional[72],
                                          dataForGraphsRegional[96],
                                          dataForGraphsRegional[120],
                                          dataForGraphsRegional[144]] : 
                                         
                                          props.target === "target_A2" ? 
                                          [dataForGraphsRegional[4],
                                          dataForGraphsRegional[28],
                                          dataForGraphsRegional[52],
                                          dataForGraphsRegional[76],
                                          dataForGraphsRegional[100],
                                          dataForGraphsRegional[124],
                                          dataForGraphsRegional[148]] :
                                         props.target === "target_A3" ? 
                                         [dataForGraphsRegional[8],
                                          dataForGraphsRegional[32],
                                          dataForGraphsRegional[56],
                                          dataForGraphsRegional[80],
                                          dataForGraphsRegional[104],
                                          dataForGraphsRegional[128],
                                          dataForGraphsRegional[152]] :
                                          props.target === "target_A4" ? 
                                         [dataForGraphsRegional[13],
                                          dataForGraphsRegional[37],
                                          dataForGraphsRegional[61],
                                          dataForGraphsRegional[85],
                                          dataForGraphsRegional[109],
                                          dataForGraphsRegional[133],
                                          dataForGraphsRegional[157]] :
                                          
                                          [dataForGraphsRegional[18],
                                          dataForGraphsRegional[42],
                                          dataForGraphsRegional[66],
                                          dataForGraphsRegional[90],
                                          dataForGraphsRegional[114],
                                          dataForGraphsRegional[138],
                                          dataForGraphsRegional[162]]

                                        }

      />  


</Row>
{/* Only B4 objective question B4_2 */}
{props.target === "target_B4" &&
   <Row className="pdf-rendering justify-content-md-center">
          
    
     {/*First graph main question */}
      <PoliciesResponsesMainSection 
        size={size}
      indicatorTitle=''
      
      indicatorText=''
      
      graphTitle='graphB41_title2'
                
      titleY='graphA11_ybar_label1'
      titleX='global_title'
      type={props.type}
      dataGlobal={dataForGraphsGlobal.slice(82,87)} 
                          dataRegional={[dataForGraphsRegional[19],
                                          dataForGraphsRegional[43],
                                          dataForGraphsRegional[67],
                                          dataForGraphsRegional[91],
                                          dataForGraphsRegional[115],
                                          dataForGraphsRegional[139],
                                          dataForGraphsRegional[163]]}

   />  

</Row>}
{/* Only B4 objective question B4_2 */}
{props.target === "target_B4" &&
   <Row className="pdf-rendering justify-content-md-center">
          
    
     {/*First graph main question */}
      <PoliciesResponsesMainSection
        size={size}
      indicatorTitle=''
      
      indicatorText=''
      
      graphTitle='graphB41_title3'
                
      titleY='graphA11_ybar_label1'
      titleX='global_title'
      type={props.type}
      dataGlobal={dataForGraphsGlobal.slice(87,92)} 
                          dataRegional={[dataForGraphsRegional[20],
                                          dataForGraphsRegional[44],
                                          dataForGraphsRegional[68],
                                          dataForGraphsRegional[92],
                                          dataForGraphsRegional[116],
                                          dataForGraphsRegional[140],
                                          dataForGraphsRegional[164]]}

   />  

</Row>}




 <br></br>
 <br></br>
      {/*Subquestions to First Question */}
       <Row className="pdf-rendering justify-content-md-center">
  <PoliciesResponsesSubSection 
    type={props.type}
    size={size}
  graphTitle={props.target === "target_A1" ? 
    ['graphA11_title2', "graphA11_title3"] : 
    props.target === "target_A2" ? 
    ['graphA21_title2', 'graphA21_title3'] :
     props.target === "target_A3" ? ['graphA31_title2' , ""] :
     props.target === "target_A4" ? ['graphA41_title2', 'graphA41_title3'] : []
  }
  isOneRow={false}  
        titleY='graphA11_ybar_label1'

 mobileLabels={props.target === "target_A1" ? ["CO", "TR", "FO" , "RD", "OT"] : 
    ["EX", "FC", "SF", "OT"]}
  subquestionsLabels={
    props.target === "target_A1" ? 
    [
    'result_conservation_FGR', 'result_FGR_transferred', 
    'result_production_fores', 'result_research_dev', 'result_other'] :  
    props.target === "target_A2" ? 
    [
    'result_in_situ_conservation', 
    'result_protected_areas', 
    'result_forests_managed',
    'result_other'] : 
     props.target === "target_A3" ? 
    [] :  
    props.target === "target_A4" ? 
    [
     "result_farmers",
     "result_forest_owners",
     "result_private_sector",
     "result_NGO",
      "result_gov_org",
      "result_research_org",
      "result_relevant_ministries",
      "result_other"] : []
  
  } 
    dataGlobalTimeline={props.target === "target_A1" ? dataForTimelineGlobalA11 : 
    props.target === "target_A2" ? dataForTimelineGlobalA21 : 
    props.target === "target_A3" ? dataForTimelineGlobalA31 :
    props.target === "target_A4" ? dataForTimelineGlobalA41 : []
  }
  
  dataGlobalDetails={props.target === "target_A1" ? 
      dataForGraphsGlobal.slice(4,9) : 
      props.target === "target_A2" ? 
      dataForGraphsGlobal.slice(22,26) :
      props.target === "target_A3" ?
      [] :
      props.target === "target_A4" ?
      dataForGraphsGlobal.slice(58,66) :
     []} 
  dataRegionalTimeline={
    props.target === "target_A1" ? [
      dataForTimelineRegional[0][0],
      dataForTimelineRegional[1][0],
      dataForTimelineRegional[2][0],
      dataForTimelineRegional[3][0],
      dataForTimelineRegional[4][0],
      dataForTimelineRegional[5][0],
      dataForTimelineRegional[6][0]] : 
    
      props.target === "target_A2" ? [
      dataForTimelineRegional[0][2],
      dataForTimelineRegional[1][2],
      dataForTimelineRegional[2][2],
      dataForTimelineRegional[3][2],
      dataForTimelineRegional[4][2],
      dataForTimelineRegional[5][2],
      dataForTimelineRegional[6][2]] : 
      props.target === "target_A3" ? [
      dataForTimelineRegional[0][4],
      dataForTimelineRegional[1][4],
      dataForTimelineRegional[2][4],
      dataForTimelineRegional[3][4],
      dataForTimelineRegional[4][4],
      dataForTimelineRegional[5][4],
      dataForTimelineRegional[6][4]] :
    props.target === "target_A4" ? [
      dataForTimelineRegional[0][6],
      dataForTimelineRegional[1][6],
      dataForTimelineRegional[2][6],
      dataForTimelineRegional[3][6],
      dataForTimelineRegional[4][6],
      dataForTimelineRegional[5][6],
      dataForTimelineRegional[6][6]] : 
    [] }
      dataRegionalDetails={props.target === "target_A1" ? [
                                          dataForGraphsRegional[1],
                                          dataForGraphsRegional[25],
                                          dataForGraphsRegional[49],
                                          dataForGraphsRegional[73],
                                          dataForGraphsRegional[97],
                                          dataForGraphsRegional[121],
                                          dataForGraphsRegional[144]] : 
                                         props.target === "target_A2" ?
                                          [dataForGraphsRegional[5],
                                          dataForGraphsRegional[29],
                                          dataForGraphsRegional[53],
                                          dataForGraphsRegional[77],
                                          dataForGraphsRegional[101],
                                          dataForGraphsRegional[125],
                                          dataForGraphsRegional[149]] : 
                                         props.target === "target_A3" ?
                                          [] : 
                                          props.target === "target_A4" ?
                                          [dataForGraphsRegional[14],
                                          dataForGraphsRegional[38],
                                          dataForGraphsRegional[62],
                                          dataForGraphsRegional[86],
                                          dataForGraphsRegional[110],
                                          dataForGraphsRegional[134],
                                          dataForGraphsRegional[158]] : []}/></Row>
  <br></br>
         <br></br>
   {/*Second graph main question */}
 <Row className="pdf-rendering justify-content-md-center">
<PoliciesResponsesMainSection
  size={size}
                      indicatorTitle={
                      props.target === "target_A1" ?  'indicatorA12_title' : 
                      props.target === "target_A2" ?  'indicatorA22_title' :
                      props.target === "target_A3" ?  'indicatorA32_title' :
                      props.target === "target_A4" ?  'indicatorA42_title' : 'indicatorB42_title'}
      
      indicatorText={props.target === "target_A1" ? 'indicatorA12_text' :
                    props.target === "target_A2" ? 'indicatorA22_text' :
                    props.target === "target_A3" ? 'indicatorA32_text' :
                    props.target === "target_A4" ? 'indicatorA42_text' : 'indicatorB42_text'}
  
      graphTitle={props.target === "target_A1" ? 'graphA12_title1' :
                  props.target === "target_A2" ? 'graphA22_title1' :
                props.target === "target_A3" ? 'graphA32_title1' :
                props.target === "target_A4" ? 'graphA42_title1' : 'graphB42_title1'
               } 
      titleY='graphA11_ybar_label1'
      type={props.type}

      dataGlobal={props.target === "target_A1" ? 
      dataForGraphsGlobal.slice(9,13) : 
      props.target === "target_A2" ? 
      dataForGraphsGlobal.slice(26,30) :
      props.target === "target_A3" ?
      dataForGraphsGlobal.slice(38,42) :
      props.target === "target_A4" ?
      dataForGraphsGlobal.slice(66,70) :
     dataForGraphsGlobal.slice(92,96)} 
       
      dataRegional={props.target === "target_A1" ? [
                                          dataForGraphsRegional[2],
                                          dataForGraphsRegional[26],
                                          dataForGraphsRegional[50],
                                          dataForGraphsRegional[74],
                                          dataForGraphsRegional[98],
                                          dataForGraphsRegional[122],
                                          dataForGraphsRegional[146]] : 
                                          
                                          props.target === "target_A2" ?
                                         
                                          [dataForGraphsRegional[6],
                                          dataForGraphsRegional[30],
                                          dataForGraphsRegional[54],
                                          dataForGraphsRegional[78],
                                          dataForGraphsRegional[102],
                                          dataForGraphsRegional[126],
                                          dataForGraphsRegional[150]] :
                                          
                                          props.target === "target_A3" ? [
                                          dataForGraphsRegional[9],
                                          dataForGraphsRegional[33],
                                          dataForGraphsRegional[57],
                                          dataForGraphsRegional[81],
                                          dataForGraphsRegional[105],
                                          dataForGraphsRegional[129],
                                          dataForGraphsRegional[153]] :
                                          
                                          props.target === "target_A4" ? [
                                          dataForGraphsRegional[15],
                                          dataForGraphsRegional[39],
                                          dataForGraphsRegional[63],
                                          dataForGraphsRegional[87],
                                          dataForGraphsRegional[111],
                                          dataForGraphsRegional[135],
                                          dataForGraphsRegional[159]] : 
                                          
                                          [dataForGraphsRegional[21],
                                          dataForGraphsRegional[45],
                                          dataForGraphsRegional[69],
                                          dataForGraphsRegional[93],
                                          dataForGraphsRegional[117],
                                          dataForGraphsRegional[141],
                                          dataForGraphsRegional[165]]} />

</Row>
<br></br>
<br></br>
<Row className="pdf-rendering justify-content-md-center">
 {/*subquestions number 2 */}

  <PoliciesResponsesSubSection 
    type={props.type}
          titleY='graphA11_ybar_label1'

  graphTitle={props.target === "target_A1" ? 
    ['graphA12_title2', "graphA12_title3"] :
    props.target === "target_A2" ?  
    ['graphA22_title2', 'graphA22_title3'] :
    ['graphA42_title2', 'graphA42_title3']
  }
  isOneRow={false}  
   size={size}
   mobileLabels={props.target === "target_A1" ? 
    ["CO", "TR", "FO" , "RD", "OT"] : 
    props.target === "target_A2" ? 
    ["EX", "FC", "SF", "OT"] : 
  props.target === "target_A3" ? ["PE", "PC", "PP", "OT"] : ["CO", "USE", "DEV"] }
  subquestionsLabels={ 
    props.target === "target_A1" ? [
    t('result_conservation_FGR'), 
    t('result_FGR_transferred'), 
    t('result_production_fores'),
    t('result_research_dev'),
    t('result_other')] :
  
    props.target === "target_A2" ?
   [t('result_ex_situ_conservation'), t('result_field_collections'), t('result_storage_facilities'), t('result_other')] :
  
   props.target === "target_A3" ? [   
    t("result_public_entities"),
      t("result_private_companies"),
      t("result_private_public_partnerships"), t('result_other')] :
  
      props.target === "target_A4" ? [t('result_conservation_FGR'), t('result_use_FGR'), t('result_development_FGR')] : []
}
  
  
   dataGlobalTimeline={props.target === "target_A1" ? dataForTimelineGlobalA12 : 
    props.target === "target_A2" ?  dataForTimelineGlobalA22 :
    props.target === "target_A3" ? [] : 
    props.target === "target_A4" ? dataForTimelineGlobalA42 : [] }
  
     dataGlobalDetails={props.target === "target_A1" ? 
      dataForGraphsGlobal.slice(13,18) : 
      props.target === "target_A2" ? 
      dataForGraphsGlobal.slice(30,34) :
      props.target === "target_A3" ?
      dataForGraphsGlobal.slice(42,46) :
      props.target === "target_A4" ?
      dataForGraphsGlobal.slice(70,73) :
     []} 

  dataRegionalTimeline={props.target === "target_A1" ? [
      dataForTimelineRegional[0][1],
      dataForTimelineRegional[1][1],
      dataForTimelineRegional[2][1],
      dataForTimelineRegional[3][1],
      dataForTimelineRegional[4][1],
      dataForTimelineRegional[5][1],
      dataForTimelineRegional[6][1]] : 
      props.target === "target_A2" ?
    [
      dataForTimelineRegional[0][3],
      dataForTimelineRegional[1][3],
      dataForTimelineRegional[2][3],
      dataForTimelineRegional[3][3],
      dataForTimelineRegional[4][3],
      dataForTimelineRegional[5][3],
      dataForTimelineRegional[6][3]]  : 
      
        props.target === "target_A3" ?
      [] : 
      props.target === "target_A4" ? [
      dataForTimelineRegional[0][7],
      dataForTimelineRegional[1][7],
      dataForTimelineRegional[2][7],
      dataForTimelineRegional[3][7],
      dataForTimelineRegional[4][7],
      dataForTimelineRegional[5][7],
      dataForTimelineRegional[6][7]] : 
    []}
   dataRegionalDetails={props.target === "target_A1" ? [
                                          dataForGraphsRegional[3],
                                          dataForGraphsRegional[27],
                                          dataForGraphsRegional[51],
                                          dataForGraphsRegional[75],
                                          dataForGraphsRegional[99],
                                          dataForGraphsRegional[123],
                                          dataForGraphsRegional[147]] : 
                                         props.target === "target_A2" ?
                                          [dataForGraphsRegional[7],
                                          dataForGraphsRegional[31],
                                          dataForGraphsRegional[55],
                                          dataForGraphsRegional[79],
                                          dataForGraphsRegional[103],
                                          dataForGraphsRegional[127],
                                          dataForGraphsRegional[151]] :
                                          props.target === "target_A3" ?
                                          [dataForGraphsRegional[10],
                                          dataForGraphsRegional[34],
                                          dataForGraphsRegional[58],
                                          dataForGraphsRegional[82],
                                          dataForGraphsRegional[106],
                                          dataForGraphsRegional[130],
                                          dataForGraphsRegional[154]] : 
                                          props.target === "target_A4" ?
                                          [dataForGraphsRegional[16],
                                          dataForGraphsRegional[40],
                                          dataForGraphsRegional[64],
                                          dataForGraphsRegional[88],
                                          dataForGraphsRegional[112],
                                          dataForGraphsRegional[136],
                                          dataForGraphsRegional[160]] : []}/>

    </Row>
    <br></br>
<br></br>

  {/*Only for Target A3, A4 and B4 third main question A3.3 A4.3 and B4.3 */}
  {props.target === "target_A3" || props.target === "target_A4" || props.target === "target_B4" ?  
 <Row className="pdf-rendering justify-content-md-center">
<PoliciesResponsesMainSection
  size={size}
                      indicatorTitle={
                      props.target === "target_A3" ?  'indicatorA33_title' :
                      props.target === "target_A4" ?  'indicatorA43_title' : 'indicatorB43_title'}
      
      indicatorText={props.target === "target_A3" ? 'indicatorA33_text' :
                    props.target === "target_A4" ? 'indicatorA43_text' : 'indicatorB43_text'}
  
      graphTitle={props.target === "target_A3" ?  'graphA33_title1' :
                  props.target === "target_A4" ? 'graphA43_title1' : 'graphB43_title1'} 
      titleY='graphA11_ybar_label1'
      type={props.type}

      dataGlobal={props.target === "target_A3" ?
      dataForGraphsGlobal.slice(46,50) :
      props.target === "target_A4" ?
      dataForGraphsGlobal.slice(73,77) :
     dataForGraphsGlobal.slice(96,101)} 
       
                dataRegional={ props.target === "target_A3" ? [
                                          dataForGraphsRegional[11],
                                          dataForGraphsRegional[35],
                                          dataForGraphsRegional[59],
                                          dataForGraphsRegional[83],
                                          dataForGraphsRegional[107],
                                          dataForGraphsRegional[131],
                                          dataForGraphsRegional[155]] :
                                          
                                          props.target === "target_A4" ? [
                                          dataForGraphsRegional[17],
                                          dataForGraphsRegional[41],
                                          dataForGraphsRegional[65],
                                          dataForGraphsRegional[89],
                                          dataForGraphsRegional[113],
                                          dataForGraphsRegional[137],
                                          dataForGraphsRegional[161]] : 
                                          
                                          [dataForGraphsRegional[22],
                                          dataForGraphsRegional[46],
                                          dataForGraphsRegional[70],
                                          dataForGraphsRegional[94],
                                          dataForGraphsRegional[118],
                                          dataForGraphsRegional[142],
                                          dataForGraphsRegional[166]]} />

</Row> : <div></div>}
<br></br>
<br></br>
 {/*Only for Target A3, A4 and B4 third sub question A3.3 A4.3 and B4.3 */}
  {props.target === "target_A3" || props.target === "target_A4" || props.target === "target_B4"  ?
  <Row className="pdf-rendering justify-content-md-center">
 {/*subquestions number 3 */}

  <PoliciesResponsesSubSection 
    type={props.type}
  graphTitle={props.target === "target_A3" ? 
    ['graphA33_title2', "graphA33_title3"] : 
    props.target === "target_A4" ? 
    [] : ['', "graphB43_title2"]}
  isOneRow={false}  
   size={size}
   mobileLabels={props.target === "target_A3" ? ["FA", "LC", "FO" , "OT"] : 
    []}
  subquestionsLabels={ props.target === "target_A3" ? [
      t('result_farmers'), 
    t('result_local_communities'), 
    t('result_forest_owners'),
    t('result_other')] :
    props.target === "target_A4" ?
      [] : [] }
  
  
   dataGlobalTimeline={
    props.target === "target_A3" ? dataForTimelineGlobalA33 : 
     [] }
  
     dataGlobalDetails={props.target === "target_A3" ?
      dataForGraphsGlobal.slice(50,54) : []} 

  dataRegionalTimeline={
        props.target === "target_A3" ?
      [
      dataForTimelineRegional[0][5],
      dataForTimelineRegional[1][5],
      dataForTimelineRegional[2][5],
      dataForTimelineRegional[3][5],
      dataForTimelineRegional[4][5],
      dataForTimelineRegional[5][5],
      dataForTimelineRegional[6][5]] : 
     
    []}
   dataRegionalDetails={props.target === "target_A3" ?
                                          [dataForGraphsRegional[12],
                                          dataForGraphsRegional[35],
                                          dataForGraphsRegional[60],
                                          dataForGraphsRegional[84],
                                          dataForGraphsRegional[108],
                                          dataForGraphsRegional[132],
                                          dataForGraphsRegional[156]] : 
                                          props.target === "target_B4" ?
                                          [dataForGraphsRegional[23],
                                          dataForGraphsRegional[47],
                                          dataForGraphsRegional[71],
                                          dataForGraphsRegional[95],
                                          dataForGraphsRegional[119],
                                          dataForGraphsRegional[143],
                                          dataForGraphsRegional[167]] : []}/>

    </Row> : <div></div>}
 <br></br>
 <br></br>

   </Container>}
      </div>
    );
  };
  
  export default GlobalRegionalDistributionGraphs;
  
